import React, { Component } from "react";
import { Form, Modal } from "react-bootstrap";
import Select from "react-select";
import ChecklistService from "../../services/ChecklistService";
import placeholderImage from "./../../assets/images/image-placeholder.png";
import UserService from "../../services/UserService";
import MroCategoryService from "../../services/MroCategoryService";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import Moment from "moment";
import InspectionService from "../../services/InspectionService";
import imageCompression from "browser-image-compression";
import Alerts from "../common/Alerts";
import { Link } from "react-router-dom";
import back from "./../../assets/images/back.svg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CustomToolbar from "../CustomToolbar";
import LinkModal from "../LinkModal";
import Collapsible from "react-collapsible";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color:
      state.isSelected && state.isFocused
        ? "white"
        : state.isSelected
        ? "black"
        : state.isFocused && "white",
    backgroundColor:
      state.isSelected && state.isFocused ? "gray" : state.isFocused && "gray",
    fontFamily: "Roboto-Regular",
    fontSize: "16px",
  }),
};
class App extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.quillRef = React.createRef();
    this.state = {
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
      errors: {},
      input: {},
      isSubmit: false,
      isLoading: false,
      showAlertModal: false,
      showConfirmModel: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      checklist_slug: this.props.match.params.checklist_slug,
      property_slug: this.props.match.params.property_slug,
      zone_type: this.props.match.params.zone_type,
      locationName: "",
      isResume: this.props.location.state?.isResume || false,
      property_inspection_perform:
        this.props.location.state?.property_name || "",
      error: "",
      openCollapsibleId: [],
      openIndex: false,
      status: Array.isArray(global.inspectionStatusWeb)
        ? global.inspectionStatusWeb
        : global.inspectionStatusWeb,
      steps: [
        {
          key: "firstStep",
          label: "Info",
          isDone: true,
          component: this.firstComponent,
        },
        {
          key: "secondStep",
          label: "Inspect",
          isDone: false,
          component: this.secondComponent,
        },
        {
          key: "finalStep",
          label: "Review",
          isDone: false,
          component: this.thirdComponent,
        },
      ],
      activeStep: {
        key: "firstStep",
        label: "Info",
        isDone: true,
        component: this.firstComponent,
      },
      propertyList: [],
      zoneTypeList: [],
      is_open: 0,
      showBasicModal: false,
      isCreateMroChecked: false,
      isCreateMroCheckedBoxShow: false,
      priorityType: global.priorityType,
      selectedPriorityType: [],
      mroCategory: [],
      selectedMroCategory: [],
      userList: [],
      selectedUserList: [],
      in_time: Moment(new Date()).toDate("dd-MM-YYYY | hh:mm A"),
      out_time: "",
      is_image: false,
      login_user: global.userData.full_name,
      note: undefined,
      mroCreated: false,
      isImage: false,
      arrAllImages: [],
      arrAllImages1: [],
      status_id: 1,
      deletedImages: [],
    };
    this.bindMethods();
  }
  bindMethods() {
    this.closeModal = this.closeModal.bind(this);
    this.submitModalforNote = this.submitModalforNote.bind(this);
    this.saveOrUpdateInspection = this.saveOrUpdateInspection.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleChangeUserList = this.handleChangeUserList.bind(this);
    this.handleChangePriority = this.handleChangePriority.bind(this);
    this.handleChangeMroCategory = this.handleChangeMroCategory.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.changeHandlerForNote = this.changeHandlerForNote.bind(this);
    this.imagePreview = this.imagePreview.bind(this);
    this.handleAnswerOptionClick = this.handleAnswerOptionClick.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.checkInspectionAvailableOnChecklistInLocal =
      this.checkInspectionAvailableOnChecklistInLocal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleModalRemove = this.handleModalRemove.bind(this);
    this.handleLink = this.handleLink.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalSubmit = this.handleModalSubmit.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
  }
  async componentDidMount() {
    const { checklist_slug } = this.state;
    if (checklist_slug !== undefined) {
      await Promise.all([this.getLocation()]);
      if (this.state.isResume) {
        const inspectionSlug = this.props.location.state?.inspectionSlug;
        if (inspectionSlug) {
          await this.inspectionDetail(inspectionSlug);
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.quillRef.current && !prevState.note && this.state.note) {
      const quill = this.quillRef.current.getEditor();
      if (quill) {
        quill.getModule("toolbar").addHandler("link", this.handleLink);
        // Add event listener for clicks on links
        quill.root.addEventListener("click", this.handleLinkClick);
      }
    }
  }

  customValidate() {
    let isValid = true;
    return isValid;
  }
  closeModal() {
    this.setState({ showBasicModal: false });
  }

  async getLocation() {
    var locationList = [];
    var locationListData = [];
    var queryString =
      "is_web=1&filter_value=&property_slug=" +
      this.state.property_slug +
      "&zone_type=" +
      this.state.zone_type;
    let res = await ChecklistService.getLocationZoneAndPropertyWise(
      queryString
    );
    if (global.successStatus.includes(res.status)) {
      locationList = res.data ? (res.data.data ? res.data.data : res.data) : [];
    }
    // Ensure locationList is an array
    if (Array.isArray(locationList)) {
      locationList.forEach((item) => {
        locationListData.push({
          label: item.name,
          value: item.slug,
        });
      });
    } else {
      console.error("locationList is not an array:", locationList);
    }
    this.setState({ locationList: locationListData });
  }
  // Location Change Handler
  handleChangeLocation(value) {
    this.setState({
      selecteLocationList: value,
      location_slug: value.value,
      location_name: value.label,
      zone_type_id: value.zone_type_id,
    });
    this.setState({ confirm_back: 1 });
  }
  firstComponent = () => {
    const { isResume, location_name, in_time } = this.state;

    return (
      <div>
        <div className="row row-xs">
          {this.state.description && (
            <div>
              <label className="form-label text-left mb-0">
                Template Description
              </label>
              <p className="text-left mb-2">{this.state.description}</p>
            </div>
          )}
          <div className="col-md-12 mg-b-10">
            <h4 className="form-label text-left mg-b-0">
              {this.state.checklist_name_heading}
            </h4>
            <span className="category_name">
              <strong>{this.state.zone_name_heading}</strong>
            </span>
          </div>

          {/* Location Field */}
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">Location</label>
            {isResume ? (
              <Form.Control
                readOnly
                value={location_name}
                className="form-control max_width_100"
              />
            ) : (
              <Select
                className="multiselect new_drop"
                menuPlacement="auto"
                value={this.state.selecteLocationList}
                options={this.state.locationList}
                onChange={(value) => this.handleChangeLocation(value)}
                defaultValue={this.state.selecteLocationList}
                autoComplete="off"
                getOptionValue={(option) => `${option.label}`}
                styles={customStyles}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary75: "#808080",
                    primary50: "#808080",
                    primary25: "#808080",
                  },
                })}
              />
            )}
            {!isResume && this.state.location_slug == undefined && (
              <div className="text-danger">
                {this.state.location_slug_error}
              </div>
            )}
          </div>

          {/* In-Time Field */}
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">In-Time</label>
            {isResume ? (
              <Form.Control
                readOnly
                value={Moment(in_time).format("DD MMM yyyy | hh:mm a")}
                className="form-control max_width_100"
              />
            ) : (
              <DatePicker
                className="form-control max_width_100"
                showMonthDropdown
                showYearDropdown
                autoComplete="off"
                yearDropdownItemNumber={global.yearDropdownItemNumber}
                name="in_time"
                placeholderText="mm-dd-yyyy"
                dateFormat="dd MMM yyyy | hh:mm a"
                selected={this.state.in_time}
                onChange={(data) =>
                  this.changeHandler({
                    target: {
                      type: "date",
                      name: "in_time",
                      value: data,
                    },
                  })
                }
              />
            )}
          </div>

          {/* Technician Field - Always read-only */}
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">Technician</label>
            <Form.Control
              name="user_slug"
              className="form-control max_width_100"
              type="text"
              value={this.state.login_user}
              readOnly
            />
          </div>
        </div>
      </div>
    );
  };
  /* *************************************** END FIRST COMPONENT ******************************* */
  // Get Checklist data
  async inspectionDetail(inspectionSlug) {
    var resData = [];
    let res = await InspectionService.getInspectionBySlug(inspectionSlug);
    if (global.successStatus.includes(res.status)) {
      resData = res.data ? res.data.data : [];
      resData.property_name = resData.property
        ? resData.property.property_name
        : [];
      resData.property_inspection_perform = resData.property
        ? resData.property.property_name
        : "";
      resData.is_enable_weight = resData.checklist ? resData.checklist.is_enable_weight : 0;
      if (resData.in_time) {
        resData.in_time = Moment(resData.in_time).isValid()
          ? Moment(resData.in_time).toDate()
          : new Date();
      } else {
        resData.in_time = new Date();
      }
      let taskImages = {};
      let newCategory = resData.category.map((category) => {
        category["is_selected_category"] = 0;
        category["slug"] = category.slug ? category.slug : null;
        category['category_score'] = category.category_score ?? 0;
        category['total_possible_score'] = category.total_possible_score ?? 0;
         category["inspection_cate_percentage"] =
          category.inspection_cate_percentage ?? 0;
        category["inspection_cate_task_pass"] = category.inspection_cate_task_pass ?? 0;
        category["inspection_cate_task_total"] =
          category.inspection_cate_task_total ?? 0;
        
        category.tasks.map((task) => {
          // Basic task properties
          task["slug"] = task.slug ?? null;
          task["is_selected"] =
            task.is_mro_with_note != 0 || task.task_status != 0 ? 1 : 0;
          task["is_mro_with_note"] = task.is_mro_with_note ?? 0;
          task["task_status"] = task.task_status
            ? parseInt(task.task_status)
            : 0;
          task["checked"] = task.is_mro_with_note === 1 ? true : false;

          // Initialize empty images array
          task["images"] = [];

          // Only set MRO-related properties if MRO exists
          if (task.mro) {
            task["note_with_mro_slug"] = task.mro.slug ? task.mro.slug : null;
            task["note"] = task.mro.note ? task.mro.note : null;
            task["mro_category"] = null;
            task["mro_priority"] = task.mro.priority_type_name
              ? task.mro.priority_type_name
              : null;
            task["mro_priority_id"] = task.mro.priority_type
              ? task.mro.priority_type
              : null;
            task["mro_technician"] =
              task.mro.user && task.mro.user.full_name
                ? task.mro.user.full_name
                : null;
            task["mro_technician_slug"] =
              task.mro.user && task.mro.user.slug ? task.mro.user.slug : null;
            task["zone_type"] = task.mro.zone_type ?? null;
            task["zone_type_name"] = task.mro.zone_type_string ?? null;
            task["due_date"] = task.mro.due_date ? task.mro.due_date : null;
            task["images"] = task.mro.images ? task.mro.images : [];
          } else {
            // Set defaults when no MRO exists
            task["note_with_mro_slug"] = null;
            task["note"] = null;
            task["mro_category"] = null;
            task["mro_priority"] = null;
            task["mro_priority_id"] = null;
            task["mro_technician"] = null;
            task["mro_technician_slug"] = null;
            task["due_date"] = null;
          }
          task["zone_type"] = resData.zone_type
            ? resData.zone_type.zone_type_id
            : null;
          task["zone_type_name"] = resData.zone_type
            ? resData.zone_type.zone_type_name
            : null;
          task["location_slug"] = resData.location_slug
            ? resData.location_slug
            : null;
          task["location_name"] = resData.location_name
            ? resData.location_name
            : null;
          task['possible_score'] = task.possible_score ?? 0;
          task['task_score'] = (task.actual_score != null && task.actual_score !== undefined && task.actual_score !== "")
            ? task.actual_score
            : 0;

          if (task.checklist_task_id) {
            taskImages[task.checklist_task_id] = task.images;
          }

          return task;
        });
        return category;
      });
      resData.category = newCategory ? newCategory : "";
      this.setState({ taskImages });
    } else {
      let alertMessage = "";
      if (res.data.result.errorDetail !== null) {
        let errors = {};
        res.data.errorCode = "Validation Failed";
        res.data.result.errorDetail.forEach((item) => {
          errors[item.errorField] = item.errorMessage[0];
          res.data.errorMessage = "";
        });
        this.setState({ errors: errors });
      }
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.message ? res.data.message : "Error!",
        alertModalMessage:
          alertMessage !== "" ? alertMessage : res.data.message,
      });
    }
    this.setState(resData);
    this.setState({
      locationName: this.state.selecteLocationList
        ? this.state.selecteLocationList.label
        : "",
    });
    this.setState({
      category: resData.category,
      openCollapsibles: Array(resData.category?.length || 0).fill(true),
    });
    this.setState({
      property_inspection_perform: resData.property.property_name,
    });
    this.setState({ checklist_name_heading: resData.checklist_name });
    this.setState({ zone_name_heading: resData.location_name });
    this.setState({ checklist_slug: resData.checklist.slug });
    this.setState({ property_slug: resData.property.slug });
    this.setState({ location_name: resData.location_name });
    this.setState({ location_slug: resData.location_slug });
    this.setState({ is_enable_weight: resData.is_enable_weight });
  }
  /* click on task checkbox */
  handleCheckboxClick(e, index, indexes) {
    // e.preventDefault();
    let CheckChecked = e.target.checked;
    let category = this.state.category;
    let currentCategory = this.state.category[index];
    let curentTask = currentCategory.tasks[indexes];
    if (CheckChecked === true) {
      currentCategory.is_selected_category = 1;
      curentTask.is_open = 1;
      curentTask.is_selected = 1;
    } else {
      currentCategory.is_selected_category = 0;
      curentTask.is_open = 0;
      curentTask.is_selected = 0;
      curentTask.task_status = null;
    }
    // this.setState({ category: category, mroCreated: isMro });
    this.setState({ category: category });
    this.localDataStorage(this.state.category);
  }
  /* YES NO NOTE ANSWER HANDLER */
handleAnswerOptionClick(ev, index, indexes) {
  ev.preventDefault();
  let nameOfEvent = ev.target.value;
  let category = this.state.category;
  let currentCategory = this.state.category[index];
  let curentTask = currentCategory.tasks[indexes];

  if (nameOfEvent === "YES" || nameOfEvent === "NO" || nameOfEvent === "NA") {
    const statusMap = {
      YES: 1,
      NO: 2,
      NA: 3,
    };

    category[index].tasks[indexes].task_status = statusMap[nameOfEvent];
    currentCategory.is_selected_category = 1;
    curentTask.is_open = 1;
    curentTask.is_selected = 1;

    // Call score calculation first
    this.getCategoryScore(index, () => {
      const updatedCategory = this.state.category[index];
      const updatedTask = updatedCategory.tasks[indexes];

      const responseData = {
        inspection_checklist_category_slug: updatedCategory.inspection_checklist_category_slug,
        category_name: updatedCategory.category_name,
        category_score: updatedCategory.category_score ?? 0,
        inspection_cate_percentage: updatedCategory.inspection_cate_percentage,
        inspection_cate_task_pass: updatedCategory.inspection_cate_task_pass,
        inspection_cate_task_total: updatedCategory.inspection_cate_task_total,
        total_actual_score: currentCategory.totalActualScore || 0,
        total_possible_score: currentCategory.totalPossibleScore || 0,
        task: {
          inspection_checklist_task_slug: updatedTask.inspection_checklist_task_slug,
          task_name: updatedTask.task_name,
          is_exclude: updatedTask.is_exclude,
          is_selected: 1,
          is_mro_with_note: updatedTask.is_mro_with_note,
          mro_category_slug: updatedTask.mro_category_slug,
          task_status: statusMap[nameOfEvent],
          note: updatedTask.note,
          mro_priority: updatedTask.mro_priority,
          mro_priority_id: updatedTask.mro_priority_id,
          mro_technician: updatedTask.mro_technician,
          mro_technician_slug: updatedTask.mro_technician_slug,
          zone_type: updatedTask.zone_type ? updatedTask.zone_type.zone_type_id : null,
          zone_type_name: updatedTask.zone_type ? updatedTask.zone_type.zone_type_name : null,
          location_slug: updatedTask.location_slug,
          location_name: updatedTask.location_name,
          due_date: updatedTask.due_date,
          checked: updatedTask.checked,
          is_open: updatedTask.is_open,
          possible_score: updatedTask.possible_score ?? 0,
          task_score: updatedTask.task_score ?? updatedTask.actual_score ?? 0,
        },
      };

      this.setState({ responseData, category }, () => {
        this.inspectionSave(); // Save only after state is updated
      });
    });

    return; // stop further execution until callback runs
  }

  if (nameOfEvent === "NOTE") {
    this.mroAndNoteDataSet(category, index, indexes);
    this.setState({
      showBasicModal: true,
      index: index,
      indexes: indexes,
    });
  }
}

  /* Set mro and note data */
  mroAndNoteDataSet(category, index, indexes) {
    var selectedPriorityType = {
      label: category[index].tasks[indexes].mro_priority ?? null,
      value: category[index].tasks[indexes].mro_priority_id ?? null,
    };
    var selectedUserList = {
      label: category[index].tasks[indexes].mro_technician ?? null,
      value: category[index].tasks[indexes].mro_technician_slug ?? null,
    };
    var selectedMroCategory = {
      label: category[index].tasks[indexes].mro_category ?? null,
      value: category[index].tasks[indexes].mro_category_slug ?? null,
    };
    var selecteLocationList = {
      label:
        category[index].tasks[indexes].location_name ??
        this.state.selecteLocationList?.label ??
        this.state.location_name ??
        "",
      value:
        category[index].tasks[indexes].location_slug ??
        this.state.selecteLocationList?.value ??
        this.state.location_slug ??
        "",
    };
    var selectedZoneTypeList = {
      label: category[index].tasks[indexes].zone_type_name ?? null,
      value: category[index].tasks[indexes].zone_type ?? null,
    };
    var newDate =
      category[index].tasks[indexes].due_date != undefined
        ? Moment(category[index].tasks[indexes].due_date).toDate(
            "dd-MM-YYYY | hh:mm A"
          )
        : "";
    this.setState({
      task_name: category[index].tasks[indexes].task_name,
      task_slug: category[index].tasks[indexes].slug,
      property_name:
        this.state.property_name ?? this.state.property_inspection_perform,
      note: category[index].tasks[indexes].note,
      checked: category[index].tasks[indexes].checked,
      selectedPriorityType: selectedPriorityType,
      selectedUserList: selectedUserList,
      user_slug: category[index].tasks[indexes].user_slug,
      due_date: newDate,
      selectedMroCategory: selectedMroCategory,
      selecteLocationList:
        selecteLocationList ?? this.state.selecteLocationList,
      selectedZoneTypeList: selectedZoneTypeList,
      arrAllImages: category[index].tasks[indexes].images,
    });
  }

  /* handle mro and node submission */
  submitModalforNote = async (e) => {
    e.preventDefault();
    var category = this.state.category;
    var index = this.state.index;
    var indexes = this.state.indexes;
    let currentCategory = this.state.category[index];
    let curentTask = currentCategory.tasks[indexes];

    const updatedArrImage1 = this.state.arrAllImages1.map((image) => ({
      ...image,
      isNew: false,
      isUploaded: true,
    }));
    if (this.state.checked === false) {
      if (this.state.note != undefined) {
        category[index].tasks[indexes].is_mro_with_note = 2;
        category[index].tasks[indexes].checked = false;
        currentCategory.is_selected_category = 1;
        curentTask.is_open = 1;
        curentTask.is_selected = 1;
        const responseData = {
          inspection_checklist_category_slug:
            currentCategory.inspection_checklist_category_slug,
          category_name: currentCategory.category_name,
          inspection_cate_percentage: currentCategory.inspection_cate_percentage,
          inspection_cate_task_pass: currentCategory.inspection_cate_task_pass,
          inspection_cate_task_total: currentCategory.inspection_cate_task_total,
          category_score: currentCategory.category_score ?? 0,
          total_actual_score: currentCategory.total_actual_score || 0,
          total_possible_score: currentCategory.total_possible_score || 0,
          task: {
            inspection_checklist_task_slug:
              curentTask.inspection_checklist_task_slug,
            task_name: curentTask.task_name,
            is_exclude: curentTask.is_exclude,
            is_selected: 1,
            is_mro_with_note: 2,
            mro_category_slug: curentTask.mro_category_slug,
            task_status: curentTask.task_status,
            note: curentTask.note,
            mro_priority: curentTask.mro_priority,
            mro_priority_id: curentTask.mro_priority_id,
            mro_technician: curentTask.mro_technician,
            mro_technician_slug: curentTask.mro_technician_slug,
            zone_type: curentTask.zone_type,
            zone_type_name: curentTask.zone_type_name,
            location_slug: curentTask.location_slug,
            location_name: curentTask.location_name,
            due_date: curentTask.due_date,
            checked: false,
            is_open: 1,
            possible_score: curentTask.possible_score ?? 0,
            task_score: curentTask.task_score ?? curentTask.actual_score ?? 0,
            deleted_images: this.state.deletedImages,
          },
        };
        await new Promise((resolve) => {
          this.setState(
            {
              responseData: responseData,
              showBasicModal: false,
              noteMessage: "",
              deletedImages: [],
            },
            resolve
          );
        });
        this.mroAndNoteDataSet(category, index, indexes);
        var resStepTwo = await this.inspectionSave();
        if (resStepTwo === true) {
          this.getImageForUpload();
        }

        await new Promise((resolve) => {
          this.setState({ arrAllImages1: updatedArrImage1 }, resolve);
        });
      } else {
        this.setState({
          noteMessage: "The note is required.",
          showBasicModal: true,
        });
      }
    }

    if (this.state.checked === true) {
      if (
        this.state.mro_technician_slug != undefined &&
        this.state.due_date != undefined
      ) {
        if (category[index].tasks[indexes].checked === true) {
          category[index].tasks[indexes].is_mro_with_note = 1;
          category[index].tasks[indexes].checked = true;
          currentCategory.is_selected_category = 1;
          curentTask.is_open = 1;
          curentTask.is_selected = 1;
            const responseData = {
            inspection_checklist_category_slug:
              currentCategory.inspection_checklist_category_slug,
            category_name: currentCategory.category_name,
            category_score: currentCategory.category_score ?? 0,
            inspection_cate_percentage: currentCategory.inspection_cate_percentage,
            inspection_cate_task_pass: currentCategory.inspection_cate_task_pass,
            inspection_cate_task_total: currentCategory.inspection_cate_task_total,
            total_actual_score: currentCategory.total_actual_score || 0,
            total_possible_score: currentCategory.total_possible_score || 0,
            task: {
              inspection_checklist_task_slug:
              curentTask.inspection_checklist_task_slug,
              task_name: curentTask.task_name,
              is_exclude: curentTask.is_exclude,
              is_selected: 1,
              is_mro_with_note: 1,
              mro_category_slug: curentTask.mro_category_slug,
              task_status: curentTask.task_status,
              note: curentTask.note,
              mro_priority: curentTask.mro_priority,
              mro_priority_id: curentTask.mro_priority_id,
              mro_technician: curentTask.mro_technician,
              mro_technician_slug: curentTask.mro_technician_slug,
              zone_type: curentTask.zone_type.zone_type_id,
              zone_type_name: curentTask.zone_type.zone_name,
              location_slug: curentTask.location_slug,
              location_name: curentTask.location_name,
              due_date: curentTask.due_date,
              checked: false,
              is_open: 1,
              possible_score: curentTask.possible_score ?? 0,
              task_score: curentTask.task_score ?? curentTask.actual_score ?? 0,
              deleted_images: this.state.deletedImages,
            },
            };

          this.mroAndNoteDataSet(category, index, indexes);
          await new Promise((resolve) => {
            this.setState(
              {
                responseData: responseData,
                showBasicModal: false,
                priority_type_error: "",
                user_slug_error: "",
                due_date_error: "",
                deletedImages: [],
              },
              resolve
            );
          });
          var resStepTw = await this.inspectionSave();

          if (resStepTw === true) {
            this.getImageForUpload();
          }

          await new Promise((resolve) => {
            this.setState({ arrAllImages1: updatedArrImage1 }, resolve);
          });
        }
      } else {
        this.setState({
          priority_type_error: "The priority field is required.",
          user_slug_error: "The assign to field is required.",
          due_date_error: "The due date is required.",
          mro_category_slug_error: "The mro category is required.",
          showBasicModal: true,
        });
      }
    }
    this.localDataStorage(category);
  };

getCategoryScore = (index, callback = null) => {
  let category = this.state.category;
  var includedTotalTasks = [];

  category[index].is_selected_category = 1;
  category[index].inspection_cate_percentage = 0.0;
  var taskList = category[index].tasks;

  for (var j in taskList) {
    if (taskList[j].is_exclude === 2) {
      includedTotalTasks.push(taskList[j]);
    }
  }

  if (includedTotalTasks.length > 0) {
    let naCount = 0;
    let passedTask = [];

    for (let i in includedTotalTasks) {
      const task = includedTotalTasks[i];
      if (task.is_selected === 1 && task.task_status === 1) {
        passedTask.push(task);
      }
      if (task.is_selected === 1 && task.task_status === 3) {
        naCount++;
      }
    }

    const totalCounts = includedTotalTasks.length - naCount;

    let percentage = 0.0;
    if (totalCounts > 0) {
      percentage = ((passedTask.length / totalCounts) * 100).toFixed(2);
    }

    category[index].inspection_cate_percentage = percentage;
    category[index].inspection_cate_task_pass = passedTask.length;
    category[index].inspection_cate_task_total = totalCounts;
  } else {
    category[index].inspection_cate_percentage = 100;
    category[index].inspection_cate_task_pass = 0;
    category[index].inspection_cate_task_total = 0;
  }

  this.setState({ category }, () => {
    if (typeof callback === 'function') {
      callback(); // ✅ Run callback after scores are set
    }
  });
};


handleActualScoreChange = (catIdx, taskIdx, value) => {
  let category = [...this.state.category];
  if (
    category[catIdx] &&
    category[catIdx].tasks &&
    category[catIdx].tasks[taskIdx]
  ) {
    category[catIdx].tasks[taskIdx].actual_score_add = value;
    
    if (value === "") {
      category[catIdx].tasks[taskIdx].task_score = "";
    } else {
      category[catIdx].tasks[taskIdx].task_score = parseInt(value, 10);
    }

    this.calculateCategoryScore(catIdx);
    this.setState({ category });
  }
};

calculateCategoryScore = (catIdx) => {
  let category = [...this.state.category];
  if (category[catIdx] && category[catIdx].tasks) {
    let totalPossibleScore = 0;
    let totalActualScore = 0;
    
    // Filter tasks where is_exclude === 2
    const includedTasks = category[catIdx].tasks.filter(task => task.is_exclude === 2);
    
    // Sum up possible and actual scores for included tasks only
    includedTasks.forEach(task => {
      // Sum possible scores
      totalPossibleScore += parseFloat(task.possible_score) || 0;
      
      // Sum actual scores (only if they have a value)
      if (task.task_score !== undefined && task.task_score !== "") {
        totalActualScore += parseFloat(task.task_score) || 0;
      }
    });
    
    // Calculate percentage (avoid division by zero)
    let percentage = totalPossibleScore > 0 
      ? parseFloat(((totalActualScore / totalPossibleScore) * 100).toFixed(2))
      : 0;
    
    // Update category with calculated scores
    category[catIdx].total_possible_score = totalPossibleScore;
    category[catIdx].total_actual_score = totalActualScore;
    category[catIdx].category_score = percentage;    
    this.setState({ category });
  }
};

generateScorePayload = (catIdx, taskIdx) => {
  const { category } = this.state;
  const currentCategory = category[catIdx];
  const currentTask = currentCategory.tasks[taskIdx];

  return {
    inspection_checklist_category_slug: currentCategory.inspection_checklist_category_slug,
    category_name: currentCategory.category_name,
    category_score: currentCategory.category_score ?? 0,
    inspection_cate_percentage: currentCategory.inspection_cate_percentage,
    inspection_cate_task_pass: currentCategory.inspection_cate_task_pass,
    inspection_cate_task_total: currentCategory.inspection_cate_task_total,
    total_actual_score: currentCategory.total_actual_score || 0,
    total_possible_score: currentCategory.total_possible_score || 0,
    task: {
      inspection_checklist_task_slug: currentTask.inspection_checklist_task_slug,
      task_name: currentTask.task_name,
      is_selected: 1,
      is_exclude: currentTask.is_exclude,
      is_mro_with_note: currentTask.is_mro_with_note,
      mro_category_slug: currentTask.mro_category_slug,
      task_status: currentTask.task_status,
      note: currentTask.note,
      mro_priority: currentTask.mro_priority,
      mro_priority_id: currentTask.mro_priority_id,
      mro_technician: currentTask.mro_technician,
      mro_technician_slug: currentTask.mro_technician_slug,
      zone_type: currentTask.zone_type ? currentTask.zone_type.zone_type_id : null,
      zone_type_name: currentTask.zone_type ? currentTask.zone_type.zone_type_name : null,
      location_slug: currentTask.location_slug,
      location_name: currentTask.location_name,
      due_date: currentTask.due_date,
      checked: currentTask.checked,
      is_open: currentTask.is_open,
      possible_score: currentTask.possible_score || 0,
      task_score: currentTask.task_score !== undefined ? currentTask.task_score : currentTask.actual_score,
    }
  };
};

// Method to send the score update
sendScoreUpdate = async (catIdx, taskIdx) => {
  const payload = this.generateScorePayload(catIdx, taskIdx);
  
  this.setState({ 
    loading: true,
    responseData: payload
  }, async () => {  // This callback runs after state is updated
    try {
      const success = await this.inspectionSave();

      if (success) {
        // Optionally, you can show a success alert or update state here if needed
       this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: "Score updated successfully.",
        }, () => {
          // Auto-hide after 2 seconds
          setTimeout(() => {
            this.setState({ showAlertModal: false });
          }, 2000);
        });
      } else {
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error",
          alertModalMessage: "Failed to update score.",
        });
      }
    } catch (error) {
      console.error("Error updating score:", error);
    } finally {
      this.setState({ loading: false });
    }
  });
};

  inspectionSave = async (e) => {
    this.setState({ loading: true, isSubmit: true });
    let inputData = this.state.responseData;
    const inspectSlug =
      this.state.isResume === true
        ? this.props.location.state?.inspectionSlug
        : this.state.inspection_slug;
    if (inputData != undefined) {
      let res = await InspectionService.updateInspection(
        inspectSlug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        let responceData = res && res.data ? res.data : [];
        this.setState({
          inspectionData: responceData,
        });

        this.setState({ loading: false, isSubmit: false });
        return true;
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.message ? res.data.message : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
    }
  };

  handleLink() {
    const quill = this.quillRef.current.getEditor();
    const range = quill.getSelection();
    if (range) {
      this.setState({
        showModal: true,
        range,
        url: "",
        text: "",
        isEditing: false,
      });
    }
  }

  handleModalClose() {
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleModalSubmit(url, text) {
    const quill = this.quillRef.current.getEditor();
    const { range } = this.state;
    if (range && url && text) {
      quill.deleteText(range.index, range.length);
      quill.insertText(range.index, text, "link", url);
      quill.setSelection(range.index + text.length);
    }
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleLinkClick(event) {
    if (event.target.tagName === "A") {
      event.preventDefault();
      const quill = this.quillRef.current.getEditor();
      const range = quill.getSelection();
      const url = event.target.getAttribute("href");
      const text = event.target.innerText;

      // Prevent Quill's tooltip from showing
      quill.blur();
      this.setState({
        showModal: true,
        range: { index: range.index, length: text.length },
        url,
        text,
        isEditing: true,
      });
    }
  }

  handleModalRemove() {
    const quill = this.quillRef.current.getEditor();
    const textLength = quill.getLength();
    // let range = { index: 0, length: textLength };

    // Get the entire content and iterate over each character
    for (let i = 0; i < textLength; i++) {
      const [link] = quill.getFormat(i, 1).link || [];
      if (link) {
        // Remove the link format only, leaving the text intact
        quill.formatText(i, 1, "link", false);
      }
    }

    this.setState({ showModal: false, url: "", text: "", isEditing: false });
  }

  handleChange(value) {
    this.setState({ note: value }, () => {
      this.customValidate();
    });
  }

  /* Handle note with MRO notes */
  changeHandlerForNote = (value) => {
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].note = value;
    this.setState({ category: category, note: value });
  };
  /* Image preview */
  imagePreview = async (event) => {
    this.setState({ isLoading: true });
    const files = event.target.files;
    const { category, index, indexes, isImage } = this.state;
    let newImage = [];
    let newImage1 = [];
    let allImages = [];
    // Validation: Check total images
    const totalImages = this.state.arrAllImages.length + files.length;
    if (totalImages > 10) {
      this.setState({
        isLoading: false,
        error: "You can only upload a maximum of 10 images.",
      });
      event.target.value = ""; // Reset the file input
      return;
    }
    if (files.length >= 1) {
      for (let i = 0; i < files.length; i++) {
        const fileSize = files[i].size;
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        if (fileSize >= 2e6) {
          // Compress the image if it's larger than 2MB
          const compressedFile = await imageCompression(files[i], options);
          allImages.push({
            file: compressedFile,
            isMrowithNote: category[index].tasks[indexes].is_mro_with_note,
            checklistTaskId: category[index].tasks[indexes].checklist_task_id,
            src: URL.createObjectURL(compressedFile),
            isNew: true, // Mark as new image
            isUploaded: false,
          });
        } else {
          category[index].tasks[indexes].images = files[i];
          allImages.push({
            file: files[i],
            isMrowithNote: category[index].tasks[indexes].is_mro_with_note,
            checklistTaskId: category[index].tasks[indexes].checklist_task_id,
            isNew: true, // Mark as new image
            isUploaded: false,
            src: URL.createObjectURL(files[i]),
          });
        }
      }
      // Merge new images with existing ones based on isImage flag
      if (isImage === true) {
        newImage = [...this.state.arrAllImages, ...allImages];
        newImage1 = [...this.state.arrAllImages1, ...allImages];
      } else {
        newImage = allImages;
        newImage1 = allImages;
      }

      /* Assign single task image into the category */
      category[index].tasks[indexes].images = newImage;
      // Update state with new images

      this.setState({
        category: category,
        isImage: true,
        arrAllImages: newImage,
        arrAllImages1: newImage1,
        isLoading: false,
        error: "",
      });
      this.localDataStorage(this.state.category);
    } else {
      this.setState({ isLoading: false });
    }
  };

  /* Image close */
  deleteImage(i) {
    const imageToDelete = this.state.arrAllImages[i];
    // Create copies of both arrays
    let arrAllImages = [...this.state.arrAllImages];
    let arrAllImages1 = [...this.state.arrAllImages1];
    let deletedImages = [...this.state.deletedImages];

    // If the image has a slug (already saved in database), add to deletedImages
    if (imageToDelete.slug) {
      deletedImages.push(imageToDelete.slug);
    }

    // Remove the image from both arrays
    arrAllImages.splice(i, 1);
    arrAllImages1.splice(i, 1);

    // Update the category state with the new images
    let category = [...this.state.category];
    category[this.state.index].tasks[this.state.indexes].images = arrAllImages;

    // Update the state with both arrays
    this.setState({
      arrAllImages,
      arrAllImages1,
      category,
      deletedImages,
    });
  }
  /* handle create mro checkbox */
  handleCheckboxChange(e) {
    let category = this.state.category;
    const checked = e.target.checked;
    /* check box checked for mro */
    if (checked === true) {
      category[this.state.index].tasks[this.state.indexes].checked = true;

      /* If action item created then call related APIs like mrocategory or technician */
      this.getMroCategoryList();
      this.getUserList();
    } else {
      category[this.state.index].tasks[this.state.indexes].checked = false;
      category[this.state.index].tasks[this.state.indexes].location_name = null;
      category[this.state.index].tasks[this.state.indexes].location_slug = null;
      category[this.state.index].tasks[this.state.indexes].mro_category = null;
      category[this.state.index].tasks[this.state.indexes].mro_category_slug =
        null;
      category[this.state.index].tasks[this.state.indexes].mro_priority = null;
      category[this.state.index].tasks[this.state.indexes].mro_priority_id =
        null;
      category[this.state.index].tasks[this.state.indexes].mro_technician =
        null;
      category[this.state.index].tasks[this.state.indexes].mro_technician_slug =
        null;
      category[this.state.index].tasks[this.state.indexes].due_date = null;
    }
    this.setState({ category: category, checked: checked });
  }
  // Get MRO Category List
  async getMroCategoryList(queryString = "") {
    var mroCategoryList = [];
    var mroCategoryListData = [];
    let res = await MroCategoryService.getMroCategoryList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      mroCategoryList = res.data ? res.data : [];
    }
    if (mroCategoryList.length > 0) {
      mroCategoryList.forEach((item) => {
        mroCategoryListData.push({
          label: item.name,
          value: item.slug,
        });
      });
    }

    this.setState({ mroCategory: mroCategoryListData });
  }
  // Get Users List
  async getUserList(queryString = "") {
    this.setState({ loading: true });
    var userList = [];
    var userListData = [];
    queryString =
      "property_slug=" +
      (this.state.property_slug ? this.state.property_slug : "");
    let res = await UserService.getUserList(
      "is_dropdown=1&is_mro=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      userList = res.data ? res.data : [];
    }

    userList.forEach((item) => {
      userListData.push({
        label: item.full_name,
        value: item.slug,
      });
    });

    this.setState({ userList: userListData });
    this.setState({ loading: false });
  }
  // MRO Category Change Handler
  handleChangeMroCategory(value) {
    let mro_category_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        mro_category_slug.push(item.value);
      });
    }
    this.setState({
      selectedMroCategory: value,
      mro_category_slug: value.value,
    });

    /* Set category data into category array */
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].mro_category =
      value.label;
    category[this.state.index].tasks[this.state.indexes].mro_category_slug =
      value.value;
    this.setState({ category: category });
    this.setState({ confirm_back: 1 });
  }
  // Priority  Change Handler
  handleChangePriority(value) {
    let priority_type = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        priority_type.push(item.value);
      });
    }
    this.setState({
      selectedPriorityType: value,
      priority_type: value.value,
      mro_priority_id: value.value,
    });
    this.setState({ confirm_back: 1 });
    /* Set category data into category array */
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].mro_priority =
      value.label;
    category[this.state.index].tasks[this.state.indexes].mro_priority_id =
      value.value;
    this.setState({ category: category });
  }

  // Technician/User Change Handler
  handleChangeUserList(value) {
    let user_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        user_slug.push(item.value);
      });
    }
    this.setState({
      selectedUserList: value,
      user_slug: value.value,
      mro_technician_slug: value.value,
    });
    this.setState({ confirm_back: 1 });
    /* Set category data into category array */
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].mro_technician =
      value.label;
    category[this.state.index].tasks[this.state.indexes].mro_technician_slug =
      value.value;
    category[this.state.index].tasks[this.state.indexes].zone_type =
      this.state.zone_type;
    category[this.state.index].tasks[this.state.indexes].location_slug =
      this.state.location_slug;
    category[this.state.index].tasks[this.state.indexes].location_name =
      this.state.location_name;
    this.setState({ category: category });
  }
  //Change handler for error and due date
  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    if (event.target.name == "out_time") {
      this.setState({
        [event.target.name]: Moment(value).toDate("dd-MM-YYYY | hh:mm A"),
        input: input,
      });
    } else {
      this.setState({ [event.target.name]: value, input: input });
    }
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };
  /* Handle due date for mro */
  handleDueDate = (e) => {
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].due_date =
      e.target.value;
    this.setState({ category: category, due_date: e.target.value });
  };

  handleToggle = (index) => {
    this.setState((prevState) => {
      const openCollapsibles = [...prevState.openCollapsibles];
      openCollapsibles[index] = !openCollapsibles[index]; // Toggle the state for the clicked category
      return { openCollapsibles };
    });
  };
  secondComponent = () => {
    const { openCollapsibles } = this.state;
    const { error } = this.state;
    const modules = {
      toolbar: {
        container: "#toolbar",
        handlers: {
          link: this.handleLink,
        },
      },
    };
    return (
      <div>
        <div className="row row-xs">
          <div className="col-md-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1">
            {this.state.description ? (
              <div>
                <label className="form-label text-left mb-0">
                  Template Description
                </label>
                <p className="text-left mb-2">
                  {this.state.description ? this.state.description : ""}
                </p>
              </div>
            ) : (
              ""
            )}
            <h4 className="form-label text-left mg-b-0">
              {" "}
              {this.state.checklist_name_heading}
            </h4>
            <span className="category_name" key={"secondComponent"}>
              <strong>{this.state.zone_name_heading}</strong>
            </span>
            {/* Category related loop */}
            {this.state.category !== undefined &&
              this.state.category.map((element, index) => (
                <div className="category_list_box" key={"cat_" + index}>
                  {/* Collapsible Component */}
                  <Collapsible
                    key={index}
                    trigger={
                      <div
                        className={`bedroom_title d-flex justify-content-between ${
                          openCollapsibles[index] ? "open" : ""
                        }`}
                        onClick={() => this.handleToggle(index)} // Pass the index
                      >
                        
                       <span className="cate_per_title">
                        {element.category_name}
                        <span className="score-badge ml-2">
                         {this.state.is_enable_weight == 1 ? (
                            `${element.category_score || 0}% (${element.total_actual_score || 0}/${element.total_possible_score || 0})`
                          ) : ""}
                        </span>
                      </span>
                        <span>{`${element.inspection_cate_percentage}% (${element.inspection_cate_task_pass}/${element.inspection_cate_task_total})`}</span>
                        <span
                          className={`Collapsible-arrow ${
                            openCollapsibles[index] ? "open" : ""
                          }`}
                        >
                          <i
                            className={`fa ${
                              openCollapsibles[index]
                                ? "fa-angle-up"
                                : "fa-angle-down"
                            }`}
                          ></i>
                        </span>
                      </div>
                    }
                    open={openCollapsibles[index]}
                  >
                    {/* Task List */}
                    {element.tasks &&
                      element.tasks.map((el, indexes) => (
                        <div className="qes_ans_box" key={"task_" + indexes}>
                          <label className="check_cust">
                            <input
                              type="checkbox"
                              checked={
                                el.task_status === 1 ||
                                el.task_status === 2 ||
                                el.is_mro_with_note === 1 ||
                                el.is_mro_with_note === 2
                              }
                              name="task_status"
                            />
                            <span className="checkmark"></span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: this.modifyTaskName(el.task_name),
                              }}
                            />
                          </label>
                          <div className="checbox_cont_div d-block">
                            <div className="d-flex align-items-end" key={"ans_" + indexes}>
                              {/* Yes */}
                              <button
                                className={
                                  "gf-btn-lg-outline mr-2 " +
                                  (el.task_status === 1
                                    ? "inspect_button_yes"
                                    : "inspect_button_new")
                                }
                                onClick={(ev) => {
                                  this.handleAnswerOptionClick(
                                    ev,
                                    index,
                                    indexes
                                  );
                                }}
                                value="YES"
                              >
                                Yes
                              </button>

                              {/* No */}
                              <button
                                className={
                                  "gf-btn-lg-outline mr-2 " +
                                  (el.task_status === 2
                                    ? "inspect_button_No"
                                    : "inspect_button_new")
                                }
                                onClick={(ev) => {
                                  this.handleAnswerOptionClick(
                                    ev,
                                    index,
                                    indexes
                                  );
                                }}
                                value="NO"
                              >
                                No
                              </button>

                              {/* Note */}
                              <button
                                className={
                                  "gf-btn-lg-outline mr-2 " +
                                  (el.is_mro_with_note === 1
                                    ? "inspect_button_Note"
                                    : el.is_mro_with_note === 2
                                    ? "inspect_button_Action"
                                    : "inspect_button_new")
                                }
                                onClick={(ev) => {
                                  this.handleAnswerOptionClick(
                                    ev,
                                    index,
                                    indexes
                                  );
                                }}
                                value="NOTE"
                              >
                                {el.is_mro_with_note === 1
                                  ? "MRO"
                                  : el.is_mro_with_note === 2
                                  ? "NOTE"
                                  : "ADD NOTE"}
                              </button>
                              {this.state.is_enable_weight == 1 && (
                              <>
                                <div className="pl-2 pd-r-70 flex-1">
                                  <label className="form-label text-left mg-b-5">
                                    Possible Score{" "}
                                  </label>
                                  <input 
                                    type="text" 
                                    value={" " +el.possible_score} 
                                    readOnly 
                                    className="form-control" 
                                  />
                                </div>
                                <div className="flex-1">
                                  <label className="form-label text-left mg-b-5">
                                    Actual Score{" "}
                                  </label>
                                  <input
                                    type="number"
                                    min={0}
                                    max={el.possible_score}
                                    value={
                                      el.task_score === 0 || el.task_score === "0"
                                      ? ""
                                      : el.task_score ?? el.actual_score ?? ""
                                    }
                                    onChange={e => {
                                      let value = e.target.value;

                                      // Allow empty value so that backspace works
                                      if (value === "") {
                                        this.handleActualScoreChange(index, indexes, "");
                                        return;
                                      }

                                      // Enforce numeric bounds
                                      let numericValue = Number(value);
                                      if (numericValue > Number(el.possible_score)) {
                                        numericValue = Number(el.possible_score);
                                      } else if (numericValue < 0) {
                                        numericValue = 0;
                                      }

                                      this.handleActualScoreChange(index, indexes, numericValue);
                                    }}
                                    onBlur={() => {
                                      this.sendScoreUpdate(index, indexes);
                                    }}
                                    className="form-control"
                                  />
                                </div>
                              </>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </Collapsible>
                </div>
              ))}
          </div>
          <Modal show={this.state.showBasicModal} centered>
            <Modal.Body className="width_402 p-4 border_radius_14">
              <span className="welcomeClose" onClick={() => this.closeModal()}>
                {global.closee}
              </span>

              <div className="row">
                <div className="col-md-12">
                  <h3 className="text-center mb-3">Notes</h3>
                  <p className="note_task_name_box font-weight-bold model_first_p">
                    <label className="form-label">Property Name :</label>{" "}
                    {this.state.property_inspection_perform}
                  </p>
                  <p className="note_task_name_box font-weight-bold model_first_p">
                    <label className="form-label">Task Name :</label>{" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.modifyTaskName(this.state.task_name),
                      }}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <label className="form-label mg-b-5">
                    {this.state.checked === true ? "Notes (Optional)" : "Notes"}
                  </label>
                  <CustomToolbar />
                  <ReactQuill
                    ref={this.quillRef}
                    theme="snow"
                    name="note"
                    value={this.state.note ?? ""}
                    onChange={this.changeHandlerForNote}
                    modules={modules}
                    formats={global.formats}
                    className="custom_editor_style"
                  />
                  {this.state.showModal && (
                    <LinkModal
                      onClose={this.handleModalClose}
                      onSubmit={this.handleModalSubmit}
                      onRemove={this.handleModalRemove}
                      url={this.state.url}
                      text={this.state.text}
                      isEditing={this.state.isEditing}
                      showModal={this.state.showModal}
                    />
                  )}
                  {this.state.checked === false ? (
                    <div className="text-danger">
                      {this.state.noteMessage != undefined
                        ? this.state.noteMessage
                        : ""}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* <input note /> */}

              <div className="note_image_box">
                <div className="">
                  <input
                    onChange={this.imagePreview}
                    type="file"
                    name="file_name"
                    tabIndex="2"
                    multiple
                    className="hidden"
                    title=""
                  />

                  {/* Image Preview */}
                  <ul className="img_view_loop">
                    {this.state.arrAllImages != undefined &&
                    this.state.arrAllImages.length > 0
                      ? this.state.arrAllImages.map((record, i) => {
                          return (
                            <li key={i}>
                              <div className="img_close">
                                <a
                                  href={record?.uri ?? record?.src ?? ""}
                                  rel="noreferrer"
                                  target="_blank"
                                >
                                  <img
                                    src={record?.uri ?? record?.src ?? ""}
                                    className="brand_list_image"
                                    alt={"note image"}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src = placeholderImage;
                                    }}
                                  />
                                </a>
                                <button
                                  type="button"
                                  className="btn btn-danger btn_remove"
                                  onClick={() => this.deleteImage(i)}
                                >
                                  <span className="fa fa-times"></span>
                                </button>
                              </div>
                            </li>
                          );
                        })
                      : ""}
                  </ul>
                </div>
                {/* Image Preview end*/}
              </div>
              {error && <p style={{ color: "red" }}>{error}</p>}
              <div className="row">
                <div className="col-md-12">
                  <div className="qes_ans_box crete_mro_checkbox">
                    <label className="check_cust">
                      <input
                        type="checkbox"
                        defaultChecked={this.state.checked}
                        name="is_exclude"
                        onChange={(e) => this.handleCheckboxChange(e)}
                        value={this.state.is_mro_with_note}
                      />
                      <span className="checkmark"></span>Create MRO
                    </label>
                  </div>
                </div>
              </div>

              <div
                className={
                  "create_mro_field_section" +
                  (this.state.checked === true ? "d-block" : "")
                }
              >
                <div className="row">
                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5">
                      MRO Category (Optional)
                    </label>
                    <Select
                      className="multiselect new_drop"
                      menuPlacement="auto"
                      value={this.state.selectedMroCategory}
                      options={this.state.mroCategory}
                      onChange={(value) => this.handleChangeMroCategory(value)}
                      defaultValue={this.state.selectedMroCategory}
                      autoComplete="off"
                      getOptionValue={(option) => `${option.label}`}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary75: "#808080",
                          primary50: "#808080",
                          primary25: "#808080",
                        },
                      })}
                    />
                  </div>

                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5">
                      Priority (Optional)
                    </label>
                    <Select
                      className="multiselect new_drop"
                      menuPlacement="auto"
                      value={this.state.selectedPriorityType}
                      options={this.state.priorityType}
                      isSearchable={true}
                      onChange={(value) => this.handleChangePriority(value)}
                      defaultValue={this.state.selectedPriorityType}
                      autoComplete="off"
                      getOptionValue={(option) => `${option.label}`}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary75: "#808080",
                          primary50: "#808080",
                          primary25: "#808080",
                        },
                      })}
                    />
                  </div>
                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5">Assign to</label>

                    <Select
                      className="multiselect new_drop"
                      menuPlacement="auto"
                      value={this.state.selectedUserList}
                      options={this.state.userList}
                      onChange={(value) => this.handleChangeUserList(value)}
                      defaultValue={this.state.selectedUserList}
                      autoComplete="off"
                      getOptionValue={(option) => `${option.label}`}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary75: "#808080",
                          primary50: "#808080",
                          primary25: "#808080",
                        },
                      })}
                    />

                    {this.state.mro_technician_slug == null ? (
                      <>
                        <div className="text-danger">
                          {this.state.user_slug_error}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5">Location</label>
                    <Select
                      className="multiselect new_drop"
                      menuPlacement="auto"
                      value={this.state.selecteLocationList}
                      options={this.state.locationList}
                      onChange={(value) => this.handleChangeLocation(value)}
                      defaultValue={this.state.selecteLocationList}
                      autoComplete="off"
                      getOptionValue={(option) => `${option.label}`}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary75: "#808080",
                          primary50: "#808080",
                          primary25: "#808080",
                        },
                      })}
                    />
                    {this.state.location_slug == undefined ? (
                      <>
                        <div className="text-danger">
                          {this.state.location_slug_error}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5">Due Date</label>

                    <DatePicker
                      className="form-control max_width_100"
                      showMonthDropdown
                      showYearDropdown
                      // scrollableYearDropdown
                      autoComplete="off"
                      yearDropdownItemNumber={global.yearDropdownItemNumber}
                      name="due_date"
                      placeholderText="mm-dd-yyyy"
                      dateFormat="dd MMM yyyy"
                      selected={this.state.due_date}
                      onChange={(data) =>
                        this.handleDueDate({
                          target: {
                            type: "date",
                            name: "due_date",
                            value: data,
                          },
                        })
                      }
                      minDate={Moment().toDate()}
                    />
                    {this.state.due_date == null ||
                    this.state.due_date === "" ? (
                      <>
                        <div className="text-danger">
                          {this.state.due_date_error}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex cnt_center row mt-3">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeModal()}
                  disabled={this.state.isLoading}
                >
                  Close
                </button>

                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block btn-thene-modal"
                  onClick={this.submitModalforNote}
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? global.loader : "Submit"}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  };

  thirdComponent = () => {
    return (
      <div>
        <div className="row row-xs">
          <div className="col-md-12 d-none">
            <div className="az-content-label titleLable pl-0">Review</div>
          </div>

          {/* <div className="col-md-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1">
            {this.state.isMro === true ? (
              <>
                <label className="text-left mg-b-5">
                  Below MROs will be automatically created.
                </label>
                <p>
                  After submitting inspection, below MROs will be automatically
                  created. You can update MRO details if needed.
                </p>
              </>
            ) : (
              <>
                <label className="text-left mg-b-5">
                  No MROs will be automatically created.
                </label>
              </>
            )}
          </div> */}

          <div className="col-md-12">
            {this.state.category != undefined
              ? this.state.category.map((element, index) => (
                  <span key={"rev" + index}>
                    {element.task_name
                      ? element.task_name.map((el, indexes) => (
                          <>
                            <span key={"revs" + indexes}>
                              {el.is_mro_with_note === 1 ? (
                                <>
                                  <p className="titleLable pl-4 insp_cat_list_box mb-1">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: this.modifyTaskName(
                                          el.task_name
                                        ),
                                      }}
                                    />
                                  </p>
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          </>
                        ))
                      : ""}
                  </span>
                ))
              : ""}
          </div>
        </div>
        <div className="row row-xs">
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">Out-Time</label>
            <DatePicker
              className="form-control max_width_100"
              showMonthDropdown
              showYearDropdown
              // scrollableYearDropdown
              autoComplete="off"
              yearDropdownItemNumber={global.yearDropdownItemNumber}
              name="out_time"
              placeholderText="mm-dd-yyyy"
              dateFormat="dd MMM yyyy | hh:mm a"
              selected={this.state.out_time}
              onChange={(data) =>
                this.changeHandler({
                  target: {
                    type: "date",
                    name: "out_time",
                    value: data,
                  },
                })
              }
            />
            {this.state.errors.out_time ? (
              <div className="text-danger">{this.state.errors.out_time}</div>
            ) : (
              this.validator.message(
                "Out Time",
                this.state.out_time,
                "required",
                { className: "text-danger" }
              )
            )}
          </div>
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">Inspection Status</label>
            <Select
              name="status"
              className="multiselect new_drop"
              menuPlacement="auto"
              value={this.state.selectedStatus}
              options={
                Array.isArray(this.state.status) ? this.state.status : []
              }
              isSearchable={true}
              onChange={(value) => this.handleChangeStatus(value)}
              defaultValue={
                Array.isArray(this.state.status) && this.state.status.length > 0
                  ? this.state.status[0]
                  : null
              }
              autoComplete="off"
              getOptionValue={(option) => `${option?.label ?? ""}`}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary75: "#808080",
                  primary50: "#808080",
                  primary25: "#808080",
                },
              })}
            />
            {this.state.errors.status ? (
              <div className="text-danger">{this.state.errors.status}</div>
            ) : (
              this.validator.message("Status", this.state.status, "required", {
                className: "text-danger",
              })
            )}
          </div>
        </div>
      </div>
    );
  };
  modifyTaskName(taskName) {
    // Create a temporary element to manipulate the HTML string
    const tempElement = document.createElement("div");
    tempElement.innerHTML = taskName;

    // Find all links in the element
    const links = tempElement.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });

    // Return the modified HTML
    return tempElement.innerHTML;
  }

  handleChangeStatus(value) {
    let status = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        status.push(item.value);
      });
    }
    this.setState({
      selectedStatus: value,
      status_id: value.value,
    });
    this.setState({ confirm_back: 1 });
  }

  handleNext = async (e) => {
    const { steps, activeStep } = this.state;
    if (steps[steps.length - 1].key === activeStep.key) {
      this.inspectionUpdate();
      return;
    }

    const index = steps.findIndex((x) => x.key === activeStep.key);

    // First Step: Create inspection and get slug
    if (activeStep.key === "firstStep") {
      // Validate required fields
      if(this.state.isResume === false) {
        if (!this.state.location_slug) {
          this.setState({
            location_slug_error: "This location field is required",
          });
          return;
        }
      }

      // this.setState({ isLoading: true });

      try {
        if (this.state.isResume === true) {
          this.setState({
            steps,
            activeStep: steps[index + 1],
          });
        } else {
          const { exists, slug } = await this.inspectionExits();
          if (!exists) {
            // No existing inspection - proceed with new one
            if (slug) {
              // Store the inspection slug in state
              this.setState({
                inspection_slug: slug,
                isLoading: false,
              });
              // Fetch inspection details using the slug
              await this.inspectionDetail(slug);

              // Proceed to the next step
              this.setState({
                steps,
                activeStep: steps[index + 1],
              });
            }
          } else {
            if (this.state.isResume) {
              this.setState({
                steps,
                activeStep: steps[index + 1],
              });
            } else {
              // Inspection exists - popup will be shown by inspectionExits()
              this.setState({ isLoading: false });
            }
          }
        }
      } catch (error) {
        console.error("Error creating inspection:", error);
        this.setState({
          isLoading: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: "Failed to create inspection. Please try again.",
        });
      }
    }
    /* Secound Continioue button  */
    if (this.state.activeStep.key === "secondStep") {
      /* Is any mro is available in the category */
      var outTime = Moment(new Date()).toDate("dd-MM-YYYY | hh:mm A");
      this.setState({
        steps,
        activeStep: steps[index + 1],
        sect: true,
        out_time: outTime,
        // isMro: isMro,
      });
    }

    this.customValidate();
  };
  isAnyCheckedTrue(data) {
    // Iterate over each category
    for (let j = 0; j < data.length; j++) {
      const tasks = data[j].task_name;
      // Iterate over each task
      for (let k = 0; k < tasks.length; k++) {
        // Check if the task is checked
        if (tasks[k].checked === true) {
          // If any task is checked, return true
          return true;
        }
      }
    }

    // If no task is checked, return false
    return false;
  }
  handleBack = () => {
    const { steps, activeStep } = this.state;
    const index = steps.findIndex((x) => x.key === activeStep.key);
    if (index === 0) return;
    steps[index].isDone = false;
    this.setState({ backIndex: index });
    this.setState({ steps, activeStep: steps[index - 1] });
  };
  checkInspectionAvailableOnChecklistInLocal = async () => {
    const localInsp = localStorage.getItem("localInsp") || "";
    var newKey = `${global.userData.slug}/${this.state.property_slug}/${this.state.checklist_slug}`;
    this.setState({
      localInsp: localInsp ? JSON.parse(localInsp) : "",
      newKey: newKey,
    });

    /* Find the key available in the existing array or not   */
    var match = false;
    if (localInsp.includes(newKey)) {
      match = true;
    }

    return match;
  };
  startNew = async () => {
    // Clear ALL local inspection data
    // localStorage.removeItem("localInsp");

    this.setState({
      showConfirmModel: false,
      isLoading: true, // Show loading state
    });

    try {
      // 1. Call inspectionCreate API to create new inspection
      const inspectionSlug = await this.inspectionCreate();
      if (inspectionSlug) {
        // 2. Store the new inspection slug in state
        this.setState({
          inspection_slug: inspectionSlug,
          isLoading: false,
        });
        // 3. Fetch inspection details using the new slug
        await this.inspectionDetail(inspectionSlug);

        // 4. Proceed to the next step
        const { steps, activeStep } = this.state;
        const nextStepIndex =
          steps.findIndex((x) => x.key === activeStep.key) + 1;
        this.setState({
          steps,
          activeStep: steps[nextStepIndex],
        });
      }
    } catch (error) {
      console.error("Error creating new inspection:", error);
      this.setState({
        isLoading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "Failed to create new inspection. Please try again.",
      });
    }
  };
  resumeHandle = async () => {
    this.setState({
      showConfirmModel: false,
      isLoading: true,
    });

    try {
      // 1. First check if inspection exists
      const inputData = {
        property_slug: this.state.property_slug,
        checklist_slug: this.state.checklist_slug,
        user_slug: global.userData.slug,
        location_slug: this.state.location_slug,
      };

      const res = await InspectionService.exitsInspection(inputData);

      if (global.successStatus.includes(res.status) && res.data) {
        // 2. If exists, get the inspection slug
        const inspectionSlug = res.data.inspection_slug;

        // 3. Load inspection details using the slug
        await this.inspectionDetail(inspectionSlug);

        // 4. Proceed to next step
        const { steps, activeStep } = this.state;
        const nextStepIndex =
          steps.findIndex((x) => x.key === activeStep.key) + 1;

        this.setState({
          steps,
          activeStep: steps[nextStepIndex],
          isLoading: false,
          inspection_slug: inspectionSlug,
        });
      } else {
        throw new Error("No existing inspection found");
      }
    } catch (error) {
      console.error("Error resuming inspection:", error);
      this.setState({
        isLoading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage:
          "Failed to resume inspection. Please try again or start new.",
      });
    }
  };

  onImageUpload = async (image) => {
    if (!image.isNew || image.isUploaded) return;
    try {
      const fileData = new FormData();
      fileData.append("file_name", image.file, image.file.name);
      fileData.append("is_mro_with_note", image.isMrowithNote);
      fileData.append("task_slug", image.task_slug);
      fileData.append("is_completed", true);
      fileData.append("refTableId", 2);
      let res = await InspectionService.uploadInspFile(fileData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          Images: res.data.fileName,
          imageUrl: res.data.filePath,
        });
        this.setState({ loading: false });
      } else if (res.status === 413) {
        this.setState({
          loading: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: "Content Too Large",
        });
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showSpinner: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } catch (error) {
      console.error("Error compressing or uploading image:", error);
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "An error occurred while processing the image.",
      });
    }
  };

  inspectionUpdate = async (e) => {
    this.setState({ loading: true, isSubmit: true });
    let inputData = {
      out_time: this.state.out_time,
      status_id: this.state.status_id,
    };
    const inspectSlug =
      this.state.isResume === true
        ? this.props.location.state?.inspectionSlug
        : this.state.inspection_slug;
    if (inputData != undefined) {
      let res = await InspectionService.InspectionLastUpdate(
        inspectSlug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        this.setState({ loading: false, isSubmit: false });
        setTimeout(
          () => this.props.history.push("/inspections"),
          global.redirect_time
        );
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.message ? res.data.message : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
    }
  };

  inspectionCreate = async () => {
    this.setState({ loading: true, isSubmit: true });
    const property_slug = this.props.match.params.property_slug ? this.props.match.params.property_slug : this.state.property_slug;
    const checklist_slug = this.props.match.params.checklist_slug ? this.props.match.params.checklist_slug : this.state.checklist_slug;
    const isEmpty = (val) => val === undefined || val === null || val === '';

    if (isEmpty(property_slug) && isEmpty(checklist_slug)) {
      window.location.href = "/dashboard";
    }
    let inputData = {
      property_slug: property_slug,
      checklist_slug: checklist_slug,
      user_slug: global.userData.slug,
      location_slug: this.state.location_slug,
      out_time: null,
      is_image: false,
      status_id: 1,
    };
    try {
      let res = await InspectionService.createInspection(inputData);
      if (global.successStatus.includes(res.status)) {
        const inspectionSlug = res.data?.inspection_slug;
        this.setState({
          loading: false,
          isSubmit: false,
          inspection_slug: inspectionSlug,
        });
        return inspectionSlug;
      } else {
        let alertMessage = res.data?.message || "Error creating inspection";
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: alertMessage,
        });
        return null;
      }
    } catch (error) {
      console.error("Error creating inspection:", error);
      this.setState({
        loading: false,
        isSubmit: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "An error occurred while creating inspection",
      });
      return null;
    }
  };

  inspectionExits = async () => {
    this.setState({ loading: true, isSubmit: true });
     const property_slug = this.props.match.params.property_slug ? this.props.match.params.property_slug : this.state.property_slug;
    const checklist_slug = this.props.match.params.checklist_slug ? this.props.match.params.checklist_slug : this.state.checklist_slug;
    const isEmpty = (val) => val === undefined || val === null || val === '';
    if (isEmpty(property_slug) && isEmpty(checklist_slug)) {
      window.location.href = "/dashboard";
    }
    let inputData = {
      property_slug: property_slug,
      checklist_slug: checklist_slug,
      user_slug: global.userData.slug,
      location_slug: this.state.location_slug,
      out_time: null,
      is_image: false,
      status_id: 1,
    };

    try {
      let res = await InspectionService.exitsInspection(inputData);
      if (global.successStatus.includes(res.status)) {
        if (Object.keys(res.data).length === 0) {
          const inspectionSlug = await this.inspectionCreate();
          return { exists: false, slug: inspectionSlug };
        } else {
          if (this.state.isResume) {
            // Go directly to the next step
            this.setState({
              loading: false,
              isSubmit: false,
              inspection_slug: res.data.inspection_slug,
            });
            return { exists: true, resumed: true };
          } else {
            // Default case: show resume confirmation modal
            this.setState({
              showConfirmModel: true,
              loading: false,
              isSubmit: false,
              inspection_slug: res.data.inspection_slug,
            });
            return { exists: true, resumed: false };
          }
        }
      } else {
        let alertMessage = res.data?.message || "Error creating inspection";
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: alertMessage,
        });
        return null;
      }
    } catch (error) {
      console.error("Error creating inspection:", error);
      this.setState({
        loading: false,
        isSubmit: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "An error occurred while creating inspection",
      });
      return null;
    }
  };

  saveOrUpdateInspection = async (e) => {
    this.setState({ loading: true, isSubmit: true });
    let inputData = {
      property_slug: this.state.property_slug,
      zone_type: this.state.zone_type,
      checklist_slug: this.state.checklist_slug,
      location_slug: this.state.location_slug,
      user_slug: global.userData.slug,
      in_time: localStorage.getItem("InTime"),
      category: this.state.category,
      out_time: this.state.out_time,
      is_image: this.state.is_image,
      // imageData: inputFilesData,
    };
    if (inputData != undefined) {
      let res = await InspectionService.createInspection(inputData);
      if (global.successStatus.includes(res.status)) {
        let responceData = res.data && res.data.data ? res.data.data : [];
        this.setState({
          inspectionData: responceData,
        });

        /* Update localstorage delete the Insp in the localstorage */

        const { localInsp, newKey } = this.state;
        /* Find the index */
        const index = localInsp
          ? localInsp.findIndex((x) => x.uniqueKey === newKey)
          : -1;
        if (index !== -1) {
          localInsp.splice(index, 1);
          await localStorage.setItem("localInsp", JSON.stringify(localInsp));
        }

        this.setState({ loading: false, isSubmit: false });
        setTimeout(
          () => this.props.history.push("/inspections"),
          global.redirect_time
        );
        this.getImageForUpload();
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.message ? res.data.message : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
    }
  };
  async getImageForUpload() {
    if (this.state.isImage === true) {
      if (this.state.arrAllImages1.length > 0) {
        this.state.arrAllImages1.forEach((image, index) => {
          var categoryResultListData = this.state.inspectionData;
          if (categoryResultListData.task_id == image.checklistTaskId) {
            image.task_slug = categoryResultListData.task_slug;
            this.onImageUpload(image);
          }
        });
      }
    }
  }
  localDataStorage = async (category) => {
    if (category !== undefined && category !== null) {
      const localInsp = localStorage.getItem("localInsp") || "";
      if (localInsp != "" && localInsp != undefined) {
        let finalLocalArr = [];

        /* conver into the object */
        var localInspObj = JSON.parse(localInsp);

        /* Check the uniq key in the array */
        const newKey = `${global.userData.slug}/${this.state.property_slug}/${this.state.checklist_slug}`;

        // find the index of unique key
        const index = localInspObj
          ? localInspObj.findIndex((x) => x.uniqueKey === newKey)
          : -1;

        // Key available in the array,  index > -1  in the existing array
        if (index !== -1) {
          const newArr = [
            {
              property_slug: this.state.property_slug,
              checklist_slug: this.state.checklist_slug,
              property_inspection_perform:
                this.state.property_inspection_perform,
              checklist_name_heading: this.state.checklist_name_heading,
              zone_name_heading: this.state.zone_name_heading,
              category: category,
              uniqueKey: newKey,
            },
          ];

          /*  remove the index from the existing array*/
          const arrAfterRemoveKey = localInspObj.filter(
            (item) => item.uniqueKey !== newKey
          );

          /* Update the new object in the existing array */
          let finalLocalArr = [...arrAfterRemoveKey, ...newArr];

          /* store new array in the localstorage */
          await localStorage.setItem(
            "localInsp",
            JSON.stringify(finalLocalArr)
          );
        }

        /* Key not avaialble in the array, Index == -1 are  find in the existing array */
        if (index === -1) {
          const newArr = [
            {
              property_slug: this.state.property_slug,
              checklist_slug: this.state.checklist_slug,
              property_inspection_perform:
                this.state.property_inspection_perform,
              checklist_name_heading: this.state.checklist_name_heading,
              zone_name_heading: this.state.zone_name_heading,
              category: category,
              uniqueKey: newKey,
            },
          ];

          /* if localInspObj get null then remove the key */
          if (localInspObj == null) {
            localStorage.removeItem("localInsp");
            /* Add new object in the existing array  =========== No need to remove the Index */
            finalLocalArr = newArr;
          } else {
            /* Add new object in the existing array  =========== No need to remove the Index */
            finalLocalArr = [...localInspObj, ...newArr];
          }

          /* store new array in the localstorage */
          await localStorage.setItem(
            "localInsp",
            JSON.stringify(finalLocalArr)
          );
        }
      } else {
        /* Create first object  */
        const newKey = `${global.userData.slug}/${this.state.property_slug}/${this.state.checklist_slug}`;
        const newData = [
          {
            property_slug: this.state.property_slug,
            checklist_slug: this.state.checklist_slug,
            property_inspection_perform: this.state.property_inspection_perform,
            checklist_name_heading: this.state.checklist_name_heading,
            zone_name_heading: this.state.zone_name_heading,
            category: category,
            uniqueKey: newKey,
          },
        ];

        // Set the final array to the local storage key
        await localStorage.setItem("localInsp", JSON.stringify(newData));
      }
    }
  };
  render() {
    const { steps, activeStep } = this.state;
    return (
      <>
        <main>
          <div className="container-fluid">
            <div className="row row-xs">
              <div className="col-md-12">
                <div className="dashbaord-pageHeadertitle heading_alignment">
                  <h3 className="flex-column">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <h3>Inspection</h3>
                      {this.state.isResume === true ? (
                        <Link
                          to={`/inspection/update/${this.props.location.state?.inspectionSlug}`}
                        >
                          <img src={back} alt="" />
                          Back
                        </Link>
                      ) : (
                        <Link
                          to={`/start-inspection-list/${this.state.checklist_slug}`}
                        >
                          <img src={back} alt="" />
                          Back
                        </Link>
                      )}
                    </div>
                    <span>{this.state.property_inspection_perform ?? ""}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-md-12 pl-0 pr-0">
              <Alerts
              show={this.state.showAlertModal}
              type={this.state.alertModalType}
              title={this.state.alertModalTitle}
              message={this.state.alertModalMessage}
              onClose={() => this.setState({ showAlertModal: false })}
              />
            </div>
          </div>
          <div className="container-fluid">
            <div className="inspection_perform_section">
              <div className="row row-xs mg-t-20 justify-content-center">
                <div className="col-md-12 col-xl-12">
                  <div className="box dashboardRightcard p-0">
                    <div className="steps">
                      <ul className="nav">
                        {steps.map((step, i) => {
                          return (
                            <li
                              key={i}
                              className={`${
                                activeStep.key === step.key ? "active" : ""
                              } ${step.isDone ? "done" : ""}`}
                            >
                              <div>
                                <span>{step.label}</span>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    <div className="step-component pd-l-70 pd-r-70">
                      <form
                        id="insp_form"
                        method="post"
                        encType="multipart/form-data"
                      >
                        {activeStep.component()}
                        <div>
                          <div className="btn-component mg-t-5 mg-md-t-0">
                            <input
                              type="button"
                              value="Back"
                              onClick={this.handleBack}
                              disabled={steps[0].key === activeStep.key}
                            />
                            <button
                              className="gf-btn-lg-stroke mg-l-2"
                              type="button"
                              onClick={this.handleNext}
                              disabled={this.state.isSubmit ? true : false}
                            >
                              {this.state.isSubmit
                                ? global.loader
                                : activeStep.key == "finalStep"
                                ? "Submit"
                                : "Continue"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Modal show={this.state.showConfirmModel} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
              <h3>Resume Inspection</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Would you like to resume inspection or would like to start new?
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.resumeHandle()}
                >
                  Resume
                </button>
                <button
                  type="button"
                  className="m-0 btn btn-success btn-block"
                  onClick={() => this.startNew()}
                >
                  Start New
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default App;
